export default "__VITE_ASSET__BFeIjYKF__"